<template>
  <v-card class="result_card"> <!--  v-bind="bind_selected" -->
    <v-layout row wrap>
      <v-flex md12 lg10 >
        <v-card-title primary-title>
          <div>
            <div class="result_title_star subheading primary--text" >
              <result-checkbox :result="result"></result-checkbox>
              <!-- <flag v-if="result.country == 'Australia'" iso="au" />
              <flag v-if="result.country != 'Australia'" iso="kr" /> -->
              <ais-highlight :result="result" attribute-name="title"></ais-highlight>
            </div>
            <div>
              <span class="snippet" v-html="result._snippetResult.content_text && `${result._snippetResult['content_text']['value']}...`"/>
            </div>
          </div>
        </v-card-title>
      </v-flex>
      <v-flex md12 lg2 >
        <v-btn small slot="activator" class="primary white--text"
           target="_blank" :href="result.url">
          <v-icon dark class="btn_icone">tab</v-icon>
          Open
        </v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import resultPanelConstructor from '../ResultPanelConstructor'
export default {
  name: 'policies-result-panel',
  extends: resultPanelConstructor,
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
